import { render, staticRenderFns } from "./MenuCenseur.vue?vue&type=template&id=bc96ba4c&scoped=true&"
import script from "./MenuCenseur.vue?vue&type=script&lang=js&"
export * from "./MenuCenseur.vue?vue&type=script&lang=js&"
import style0 from "./MenuCenseur.vue?vue&type=style&index=0&id=bc96ba4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc96ba4c",
  null
  
)

export default component.exports